module.exports = __webpack_public_path__ + "friend7.png?185433c150117bf088b68a0cbd58f256";


//////////////////
// WEBPACK FOOTER
// ./static/assets/friend7.png
// module id = 480
// module chunks = 0